"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _peractoConfig = require("@peracto/peracto-config");

var _TextInput = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/TextInput"));

var _File = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/File"));

var _Select = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Select"));

var _Checkbox = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Checkbox"));

var _Slider = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Slider"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faPlusCircle = require("@fortawesome/pro-regular-svg-icons/faPlusCircle");

var _startCase = _interopRequireDefault(require("lodash/startCase"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var CarouselForm = function CarouselForm(_ref) {
  var _theme$colors;

  var _onChange = _ref.onChange,
      _ref$state = _ref.state,
      _ref$state$slideDurat = _ref$state.slideDuration,
      slideDuration = _ref$state$slideDurat === void 0 ? 5000 : _ref$state$slideDurat,
      _ref$state$transition = _ref$state.transition,
      transition = _ref$state$transition === void 0 ? 'slide' : _ref$state$transition,
      _ref$state$transition2 = _ref$state.transitionDuration,
      transitionDuration = _ref$state$transition2 === void 0 ? 1000 : _ref$state$transition2,
      _ref$state$autoplay = _ref$state.autoplay,
      autoplay = _ref$state$autoplay === void 0 ? false : _ref$state$autoplay,
      _ref$state$pauseOnHov = _ref$state.pauseOnHover,
      pauseOnHover = _ref$state$pauseOnHov === void 0 ? true : _ref$state$pauseOnHov,
      _ref$state$showArrows = _ref$state.showArrows,
      showArrows = _ref$state$showArrows === void 0 ? true : _ref$state$showArrows,
      _ref$state$arrowsColo = _ref$state.arrowsColour,
      arrowsColour = _ref$state$arrowsColo === void 0 ? '#bababa' : _ref$state$arrowsColo,
      _ref$state$showIndica = _ref$state.showIndicators,
      showIndicators = _ref$state$showIndica === void 0 ? false : _ref$state$showIndica,
      _ref$state$indicators = _ref$state.indicatorsPosition,
      indicatorsPosition = _ref$state$indicators === void 0 ? 'below' : _ref$state$indicators,
      _ref$state$indicators2 = _ref$state.indicatorsColour,
      indicatorsColour = _ref$state$indicators2 === void 0 ? '#000' : _ref$state$indicators2,
      _ref$state$images = _ref$state.images,
      images = _ref$state$images === void 0 ? [] : _ref$state$images,
      selectedImageIndex = _ref$state.selectedImageIndex;
  var DEFAULT_IMAGE = {
    url: 'https://via.placeholder.com/600x200',
    openInNewTab: false
  };
  var config = (0, _peractoConfig.useConfig)();

  var _ref2 = config.get('editorConfig') || [],
      theme = _ref2.theme;

  var themeColours = [];

  if (theme !== null && theme !== void 0 && (_theme$colors = theme.colors) !== null && _theme$colors !== void 0 && _theme$colors.brand) {
    for (var _i = 0, _Object$entries = Object.entries(theme.colors.brand); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          label = _Object$entries$_i[0],
          colour = _Object$entries$_i[1];

      themeColours.push({
        label: (0, _startCase["default"])(label),
        value: colour
      });
    }
  }

  (0, _react.useEffect)(function () {
    return function () {
      _onChange({
        selectedImageIndex: 0
      });
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Transition Style",
    options: [{
      label: 'Slide',
      value: 'slide'
    }, {
      label: 'Fade',
      value: 'fade'
    }],
    value: transition,
    onChange: function onChange(e) {
      return _onChange({
        transition: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    label: "Transition Speed: ".concat(transitionDuration / 1000, "s"),
    min: 0,
    max: 10000,
    step: 100,
    value: transitionDuration,
    onChange: function onChange(e) {
      return _onChange({
        transitionDuration: e.target.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Autoplay",
    checked: autoplay,
    onChange: function onChange(e) {
      return _onChange({
        autoplay: e.target.checked
      });
    }
  }), autoplay && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    label: "Slide Duration: ".concat(slideDuration / 1000, "s"),
    min: 0,
    max: 10000,
    step: 100,
    value: slideDuration,
    onChange: function onChange(e) {
      return _onChange({
        slideDuration: e.target.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Pause on Hover",
    checked: pauseOnHover,
    onChange: function onChange(e) {
      return _onChange({
        pauseOnHover: e.target.checked
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Show Arrows",
    checked: showArrows,
    onChange: function onChange(e) {
      return _onChange({
        showArrows: e.target.checked
      });
    }
  }), showArrows && /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Arrows Colour",
    options: themeColours,
    value: arrowsColour,
    onChange: function onChange(e) {
      return _onChange({
        arrowsColour: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Show Indicators",
    checked: showIndicators,
    onChange: function onChange(e) {
      return _onChange({
        showIndicators: e.target.checked
      });
    }
  }), showIndicators && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Indicators Position",
    options: [{
      label: 'Below',
      value: 'below'
    }, {
      label: 'Overlay',
      value: 'overlay'
    }],
    value: indicatorsPosition,
    onChange: function onChange(e) {
      return _onChange({
        indicatorsPosition: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Indicators Colour",
    options: themeColours,
    value: indicatorsColour,
    onChange: function onChange(e) {
      return _onChange({
        indicatorsColour: e.value
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("hr", null), selectedImageIndex !== null && images && images[selectedImageIndex] && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Image",
    onChange: function onChange(value) {
      var imagesClone = _toConsumableArray(images);

      imagesClone[selectedImageIndex].url = value;

      _onChange({
        images: imagesClone
      });
    },
    value: images[selectedImageIndex].url || '',
    isInline: false
  }), /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Mobile Image",
    onChange: function onChange(value) {
      var imagesClone = _toConsumableArray(images);

      imagesClone[selectedImageIndex].mobileUrl = value;

      _onChange({
        images: imagesClone
      });
    },
    value: images[selectedImageIndex].mobileUrl || '',
    isInline: false
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Image alt text",
    onChange: function onChange(e) {
      var imagesClone = _toConsumableArray(images);

      imagesClone[selectedImageIndex].alt = e.target.value;

      _onChange({
        images: imagesClone
      });
    },
    value: images[selectedImageIndex].alt || ''
  }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Image link",
    onChange: function onChange(e) {
      var imagesClone = _toConsumableArray(images);

      imagesClone[selectedImageIndex].link = e.target.value;

      _onChange({
        images: imagesClone
      });
    },
    value: images[selectedImageIndex].link || ''
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Open in new tab",
    checked: images[selectedImageIndex].openInNewTab,
    onChange: function onChange(e) {
      var imagesClone = _toConsumableArray(images);

      imagesClone[selectedImageIndex].openInNewTab = e.target.checked;

      _onChange({
        images: imagesClone
      });
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-danger w-100 mt-2",
    onClick: function onClick(e) {
      var imagesClone = _toConsumableArray(images);

      imagesClone.splice(selectedImageIndex, 1);

      _onChange({
        images: imagesClone
      });

      _onChange({
        selectedImageIndex: selectedImageIndex > 0 ? selectedImageIndex - 1 : 0
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTrash.faTrash,
    className: "mr-2"
  }), " Remove Image")), /*#__PURE__*/_react["default"].createElement("hr", {
    className: "my-2"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-secondary w-100",
    onClick: function onClick(e) {
      var imagesClone = [].concat(_toConsumableArray(images), [DEFAULT_IMAGE]);

      _onChange({
        images: imagesClone
      });

      _onChange({
        selectedImageIndex: imagesClone.length - 1
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlusCircle.faPlusCircle,
    className: "mr-2"
  }), " Add Image"));
};

var _default = CarouselForm;
exports["default"] = _default;